<template lang="pug">
w-switch.f-boolean( 
  v-bind='$attrs'
  v-on='$listeners'
)
</template>

<script lang="js">
import WSwitch from '@/widgets/w-switch'
// import { Logger } from '@/lib/logger'

export default {
  name: 'BooleanField',
  mixins: [],
  components: { WSwitch },
  props: {},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss">
.f-boolean {
}
</style>
